"use client";

import { COOKIES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { PATH_EARN } from ".constants/links";
import { Button, Icon } from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC } from "react";
import { useCookies } from "react-cookie";

import { useGTMContext } from "@/providers";

export const LandingEarnCoinButton: FC = () => {
  const t = useTranslations("Landing");
  const { onSendGTM } = useGTMContext();
  const [cookies] = useCookies([
    COOKIES.RULES_ACCEPTED,
    COOKIES.GA_AB,
    COOKIES.GA_ABC,
    COOKIES.SEGMENT_AB,
  ]);

  return (
    <Button
      href={PATH_EARN}
      startContent={<Icon icon="toll" />}
      color="secondary"
      wide
      centerText
      onClick={onSendGTM(GE.LANDING_ADVANTAGE_EARN_COINS_BUTTON)}
      disabled={!cookies.rulesAccepted}
    >
      {t("Advantage.clause1.buttonText")}
    </Button>
  );
};
